import { render, staticRenderFns } from "./receiptUpload.vue?vue&type=template&id=40567c8f&"
import script from "./receiptUpload.vue?vue&type=script&lang=js&"
export * from "./receiptUpload.vue?vue&type=script&lang=js&"
import style0 from "./receiptUpload.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports